import { API_ERROR, RESET_API_ERROR } from "../actions";

const initialState = {
  error: null
};

export default function(state = initialState, action) {
  switch (action.type) {
    case RESET_API_ERROR:
      return Object.assign({}, state, { error: null });
    case API_ERROR:
      return Object.assign({}, state, {
        error: action.payload.error
      });
    default:
      return state;
  }
}
